import React from 'react';
import classNames from 'classnames';
import styles from './Heading.module.scss';

export interface HeadingProps {
	children?: React.ReactNode;
	className?: string;
	headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	style?:
		| 'default'
		| 'xxs'
		| 'xs'
		| 'sm'
		| 'md'
		| 'lg'
		| 'xl'
		| 'displaySm'
		| 'displayMd'
		| 'displayLg'
		| 'headlineLg'
		| 'headlineMd'
		| 'headlineSm'
		| 'headlineXs';
	textCenter?: boolean;
	uppercase?: boolean;
	id?: string;
}

export const Heading: React.FC<HeadingProps> = ({ children, className, id, headingLevel, style = 'default', textCenter, uppercase }) =>
	React.createElement(
		headingLevel,
		{
			...(id ? { id } : {}),
			className: classNames(
				styles.Heading,
				styles[`Heading___${style}`],
				{
					[styles.Heading___textCenter]: textCenter,
					[styles.Heading___uppercase]: uppercase,
				},
				className,
			),
		},
		children,
	);
